
if($('[data-average-rating]')){
$('[data-average-rating]').on('click',function(e) {
    e.stopPropagation();
    $('html,body').animate({
      scrollTop:$('#jumped___').offset().top},
      'smooth');
    
});
}
 
setTimeout(function(){
  document.querySelector('.jdgm-prev-badge.jdgm--js').addEventListener('click', function(e){
    e.stopPropagation();
    return false;
  })
},2000)
  
const yesImg = document.getElementById('yesImg_');
const notImg = document.getElementById("notImg_");
if(notImg !== null){
  notImg.addEventListener('click', function (){
  //console.log("hello Not Image")
  //const passValue = document.getElementsByClassName('custom_password');
  [...document.querySelectorAll('[name="customer[password]"]')].map((ele) => {
        if(ele.type === 'password'){
            ele.type="text";
            notImg.setAttribute("class", "eysfalse");
            yesImg.setAttribute("class", "eysTrue");
          }
  });
    
  
});
}


if(yesImg !== null){
      yesImg.addEventListener('click', function (){
          [...document.querySelectorAll('[name="customer[password]"]')].map((ele) => {
                if(ele.type === 'text'){
                    ele.type="password";
                    notImg.setAttribute("class", "eysTrue");
                      yesImg.setAttribute("class", "eysfalse");
                  }
          });
        });
  }

// WishLIst hide/Show
  let attr = document.querySelector('[enable-wishlist]');
setTimeout(function(){
  let cls = document.querySelector('.frcp-wishlist-wrapper');
  let attr_ = (attr)?attr.getAttribute('enable-wishlist'):[];
  (attr_ === 'false')? 
    (cls)?cls.classList.add('hide-wishlist'):[]
    : (cls)?cls.classList.remove('hide-wishlist'):[];
},2000);



